import { render } from "./vmemberinvitegift.vue?vue&type=template&id=70af8e97&scoped=true"
import script from "./vmemberinvitegift.vue?vue&type=script&lang=js"
export * from "./vmemberinvitegift.vue?vue&type=script&lang=js"

import "./vmemberinvitegift.vue?vue&type=style&index=0&id=70af8e97&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70af8e97"]])

export default __exports__